@if (usage) {
<div class="inline-flex flex-column gap-1 text-xs text-color-secondary">
    @if (label) {
    <div class="font-medium">{{ label }}</div>
    }
    <!-- Entrée -->
    <div class="flex justify-content-between gap-4">
        <span>Entrée</span>
        <span>{{ usage.tokens.input | number:'1.0-0' }} tok@if (usage.cost) { · {{ usage.cost.input | currency:usage.cost.currency:'code':'1.4-4' }}}</span>
    </div>
    <!-- Raisonnement + sortie : un seul prix (raisonnement facturé comme de l'output) -->
    <div class="flex justify-content-between gap-4">
        <span>Raisonnement + sortie</span>
        <span>{{ usage.tokens.thoughts | number:'1.0-0' }} + {{ usage.tokens.output | number:'1.0-0' }} tok@if (usage.cost) { · {{ usage.cost.output | currency:usage.cost.currency:'code':'1.4-4' }}}</span>
    </div>
    <!-- Recherches sur internet : poste à part, sans tokens, déjà compris dans le total -->
    @if (usage.cost && +usage.cost.webSearch > 0) {
    <div class="flex justify-content-between gap-4">
        <span>Recherches sur internet</span>
        <span>{{ usage.cost.webSearch | currency:usage.cost.currency:'code':'1.4-4' }}</span>
    </div>
    }
    <!-- Total -->
    <div class="flex justify-content-between gap-4 border-top-1 border-200 pt-1 font-medium">
        <span>Total</span>
        <span>{{ usage.tokens.total | number:'1.0-0' }} tok@if (usage.cost) { · {{ usage.cost.total | currency:usage.cost.currency:'code':'1.4-4' }}}</span>
    </div>
</div>
}
